import { getLocale } from "@/paraglide/runtime";
import { roundTo } from "../lib/percentage";
import type { ResultItem } from "./PercentCalc";

function format(item: ResultItem, locale: string): string {
  if (item.kind === "percent") {
    return `${roundTo(item.value, 2).toLocaleString(locale)}%`;
  }
  if (item.kind === "currency") {
    return roundTo(item.value, 2).toLocaleString(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
  return roundTo(item.value, 4).toLocaleString(locale);
}

/** Renders one or more computed result lines. The first line is emphasized. */
export function CalcResult({ items }: { items: ResultItem[] }) {
  const locale = getLocale();
  return (
    <dl className="space-y-2" aria-live="polite">
      {items.map((item, i) => (
        <div
          key={item.label()}
          className={
            i === 0
              ? "pct-result-zone flex items-baseline justify-between gap-4 rounded-xl px-5 py-4"
              : "flex items-baseline justify-between gap-4 px-5"
          }
        >
          <dt
            className={
              i === 0
                ? "text-sm font-medium text-muted-foreground"
                : "text-sm text-muted-foreground"
            }
          >
            {item.label()}
          </dt>
          <dd
            className={
              i === 0
                ? "pct-result font-display text-4xl font-bold sm:text-5xl"
                : "font-display text-lg font-semibold text-foreground"
            }
          >
            {format(item, locale)}
          </dd>
        </div>
      ))}
    </dl>
  );
}
